import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { TableColumn } from 'src/app/core/components/table/TableColumn';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MawbService } from 'src/app/shared/services/mawb.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ShipmentService } from 'src/app/shared/services/shipment.service';
import { convertMawb } from './convertor/mawb';
import { PalletCreationComponent } from '../pallet-creation/pallet-creation.component';
import { UploadComponent } from '../../mapping/upload/upload.component';
import {
  configurationIdMapForMother,
  motherShipperDeatilsconfiguration,
} from '../../../utils/constants/constant';
import { dateFilterInDays, filterDate } from '../../../utils/utils';
import { Days } from '../../../utils/constants/utility';
import { InvalidDialogComponent } from 'src/app/shared/errors/invalid-dialog/invalid-dialog.component';
import { BehaviourService } from 'src/app/shared/services/behaviour.service';
import { PalletDetailsComponent } from '../pallet-details/pallet-details.component';
import { createConfigArray } from '../../../utils/default-configs/configuration';
import { DgContentComponent } from './dg-content/dg-content.component';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-maw-list',
  templateUrl: './maw-list.component.html',
  styleUrls: ['./maw-list.component.scss'],
})
export class MawListComponent implements OnInit {
  selectedTabForStatus: number = 0;
  defaultMawbList = [];
  countryForm: FormGroup;
  AdvFilterForm: FormGroup;
  countries = [];
  countryServiceCodes = [];
  countryConfig;
  dateForm: FormGroup;
  @ViewChild('dialogRef')
  dialogRef!: TemplateRef<any>;
  @ViewChild('dialogdelete')
  dialogdelete!: TemplateRef<any>;
  @ViewChild('dialogfilter')
  dialogfilter!: TemplateRef<any>;
  mawbTableColumns: TableColumn[];
  mawbData: any;
  mawbList: any;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    'MAWB',
    'motherShipperAddress',
    'destinationCountry',
    'serviceCode',
    'createdDateTime',
    'noOfPallets',
    'totalWeight',
    'motherStatus',
    'delete',
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selectedOption: boolean = false;
  closedFltr = [];
  mawb = [];
  shipmentIDFltr = [];
  palletIDListFltr = [];
  destination_countryFltr = [];
  fromdateFltr: any;
  todateFltr: any;
  configInvoices: string = '';
  postalLocationApiKey: any;
  mydhlApiKey: any;
  mydhlApiPassword: any;
  looseBbx: boolean = false;
  bbxWorkflow: any;
  showDGContentID: any;
  motherShipAddresses = [];
  constructor(
    private fb: FormBuilder,
    private mawbService: MawbService,
    private configService: ConfigService,
    private shipmentService: ShipmentService,
    private errorDialogService: ErrorDialogService,
    private dialog: MatDialog,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private behaviorService: BehaviourService,
    private translate: TranslateService
  ) {
    this.getWorkflowConfig();
    this.getMotherShipAddresses();
  }

  ngOnInit(): void {
    this.getMawbList();
    this.initializationformGroup();
    this.initializedateformGroup();
    this.initializeAdvFilter();
    this.getDefaultConfiguration();
    this.getCustomerCredentialConfig();
  }

  onStatusTabChange(event) {
    this.selectedTabForStatus = event.index;
    const mawbStatusConfigs = {
      0: () =>
        (this.dataSource.data = this.mawbData.filter(
          ({ motherStatus }) => motherStatus === 'Open'
        )),
      1: () =>
        (this.dataSource.data = this.mawbData.filter(
          ({ motherStatus }) => motherStatus === 'Closed'
        )),
      default: () => ``,
    };
    return (mawbStatusConfigs[this.selectedTabForStatus] || mawbStatusConfigs.default)();
  }

  getDefaultConfiguration() {
    this.configService.getConfigs(createConfigArray(configurationIdMapForMother)).then(response => {
      response.forEach(item => {
        this.updateMotherConfigs(item?.config_id, item);
      });
    });
  }

  getMotherShipAddresses() {
    this.configService.getConfig('mother_shipperdetails').subscribe(response => {
      if (response && response[0]?.data) {
        this.motherShipAddresses = response[0]?.data.filter(shipper => shipper.workflow === 'bbx');
      }
    });
  }

  updateMotherConfigs(configId, item) {
    const formConfigs = {
      default: () => ``,
      mother_baby_destcountry_mapping: () => {
        this.countryConfig = item;
        this.countries = [];
        this.countries.push(...item.data.map(country => country.Mother_Destination_Country_Code));
      },
      default_invoice_export: () => {
        this.configInvoices = item.data[0];
        sessionStorage.setItem('isCustomInvoice', this.configInvoices);
      },
    };
    return (formConfigs[configId] || formConfigs.default)();
  }

  deleteorCloseMAWB(mawbId, action) {
    const data = {
      mawb: mawbId,
    };
    if (action == 'delete') {
      this.mawbService.deleteMother(data).subscribe((res: any) => {
        if (typeof res == 'string') {
          this.errorDialogService.openDialog(res, true);
        }
        this.getMawbList();
      });
    } else if (action === 'close') {
      this.closeMawb(data);
    }
  }

  closeMawb(data) {
    this.mawbService.closeMother(data).subscribe((res: any) => {
      if (res.Message) {
        if (typeof res.Message === 'object') {
          this.errorDialogService.openDialog(res.Message.status, true);
        } else {
          this.errorDialogService.openDialog(res.Message, true);
        }
      } else {
        if (!this.looseBbx) {
          const data1 = {
            MAWB: data.mawb,
          };
          this.printMaw(data1);
        }
      }
      this.getMawbList();
    });
  }

  printMaw(element) {
    this.shipmentService.getLabel('mawb', element.MAWB).subscribe({
      next: data => {
        this.shipmentService.labelWindowPrint(data.label);
      },
    });
  }

  printInvoice(element) {
    this.shipmentService.getInvoice(element.MAWB).subscribe({
      next: data => {
        this.shipmentService.labelWindowPrint(data.label);
      },
    });
  }

  openUploadLineItems(mawb) {
    const dialogRef = this.dialog.open(UploadComponent, {
      autoFocus: false,
      width: '75vw',
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {
        isOpeningFrom: 'uploadLineItem',
        mawb: mawb,
      },
    });
    dialogRef.afterClosed().subscribe(() => ``);
  }

  openUploadInvoices(mawb, motherStatus) {
    const dialogRef = this.dialog.open(UploadComponent, {
      autoFocus: false,
      width: '75vw',
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {
        isOpeningFrom: 'uploadInvoice',
        mawb,
        motherStatus,
      },
    });
    dialogRef.afterClosed().subscribe(() => ``);
  }

  filterServiceCodeBasedOnCountry(res) {
    this.countryServiceCodes = [];
    const selectedCountry = this.countryForm.value.selectedCountry;
    const country = res.data.filter(
      counrty => counrty.Mother_Destination_Country_Code == selectedCountry
    );
    const countryServiceCodesObjs = country[0].Mother_Destination_Service_Codes;
    this.countryServiceCodes.push(
      ...countryServiceCodesObjs.map(serviceCode => serviceCode.Mother_Destination_Service_Code)
    );
    this.countryForm.get('selectedserviceCountry').setValue(this.countryServiceCodes[0]);
  }

  initializationformGroup() {
    this.countryForm = this.fb.group({
      addressId: '',
      selectedCountry: ['', Validators.required],
      selectedserviceCountry: ['', Validators.required],
    });

    if (this.looseBbx) {
      this.countryForm.removeControl('addressId');
    }
  }

  initializedateformGroup() {
    this.dateForm = this.fb.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });
  }

  initializeAdvFilter() {
    this.AdvFilterForm = this.fb.group({
      mawb: ['', Validators.required],
      shipmentID: ['', Validators.required],
      palletIDList: ['', Validators.required],
      destination_country: ['', Validators.required],
      closed: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });
  }

  NavToPalletscreen(element) {
    const navComponent: any = this.looseBbx ? PalletDetailsComponent : PalletCreationComponent;
    const dialogRef = this.dialog.open(navComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      width: '100vw',
      data: {
        mawbId: element.MAWB,
        motherStatus: element.motherStatus,
        looseBbx: this.looseBbx,
        countryCode: element.destination_country,
        countryServiceCode: element.destination_service_code,
        additionalCharges: element?.additionalCharges,
        invoiceReference: element?.invoiceReference,
        mawbInvoiceReference: element?.mawbInvoiceReference,
        mawbInvoiceNumber: element?.mawbInvoiceNumber,
      },
    });
    dialogRef.afterClosed().subscribe(close => {
      this.getMawbList();
      return close ? this.onStatusTabChange({ index: close?.data }) : ``;
    });
  }

  countrySelected() {
    this.selectedOption = true;
    this.filterServiceCodeBasedOnCountry(this.countryConfig);
  }

  createMawb() {
    this.dialog.closeAll();
    const data: any = {
      destination_country: this.countryForm.value.selectedCountry,
      destination_service_code: this.countryForm.value.selectedserviceCountry,
    };
    if (!this.looseBbx) {
      data.addressId = this.countryForm.value?.addressId;
      const Addresses = this.motherShipAddresses?.filter(
        shipper => shipper.addressId === this.countryForm.value?.addressId
      );
      data.shipperNickName = Addresses[0].shipperNickName;
    }
    this.mawbService.createMawb(data).subscribe(() => {
      this.countryForm.reset();
      this.errorDialogService.openDialog('alert.mawbCreateSuccess', false);
      this.getMawbList();
    });
  }

  openDialogAction(mawb, action) {
    if (action == 'close' && (this.mydhlApiKey == '' || this.mydhlApiPassword == '')) {
      const msg = 'alert.myDhlApiCred';
      this.openCustomerCredentialNav(msg);
    } else {
      const dailogData = {
        message: action === 'delete' ? 'alert.deleteMawb' : 'alert.closeMawb',
      };
      const alertDialog = this.dialog.open(AlertComponent, {
        data: dailogData,
      });
      alertDialog.afterClosed().subscribe(res => {
        if (res == 'true') {
          this.deleteorCloseMAWB(mawb, action);
        } else {
          this.dialog.closeAll();
        }
      });
    }
  }

  getMawbList() {
    this.mawbService
      .getMawbList(dateFilterInDays(Days.TEN_YEARS, 'create_datetime'))
      .subscribe(data => {
        this.assignMawbsTodataSource(data);
      });
  }

  openTempDialog() {
    if (!this.looseBbx) {
      this.countryForm.get('addressId').setValue(this.motherShipAddresses[0]?.addressId);
    }
    if (this.mydhlApiKey == '' || this.mydhlApiPassword == '') {
      const msg = 'alert.myDhlApiCred';
      this.openCustomerCredentialNav(msg);
    } else {
      this.dialog.open(this.dialogRef, {
        width: '25%',
        data: '',
      });
    }
  }

  closeDialog() {
    this.dialog.closeAll();
    this.countryForm.reset();
  }

  applyFilters() {
    this.dialog.open(this.dialogfilter, { data: '' });
  }

  applyAdvFilter() {
    this.dialog.closeAll();

    if (this.AdvFilterForm.value.startDate) {
      this.fromdateFltr = filterDate(this.AdvFilterForm.value.startDate._d);
    }
    if (this.AdvFilterForm.value.endDate) {
      this.todateFltr = filterDate(this.AdvFilterForm.value.endDate._d);
    }
    if (this.AdvFilterForm.value.closed) {
      this.closedFltr.push(this.AdvFilterForm.value.closed);
    } else {
      this.AdvFilterForm.value.closed = '';
      this.closedFltr.push(this.AdvFilterForm.value.closed);
    }
    this.shipmentIDFltr.push(this.AdvFilterForm.value.shipmentID);
    this.palletIDListFltr.push(this.AdvFilterForm.value.palletIDList);
    this.destination_countryFltr.push(this.AdvFilterForm.value.destination_country);
    this.mawb.push(this.AdvFilterForm.value.mawb);
    let data;
    if (!this.AdvFilterForm.value.startDate) {
      data = {
        closed: this.closedFltr,
        mawb: this.mawb,
        shipmentID: this.shipmentIDFltr,
        palletIDList: this.palletIDListFltr,
        destination_country: this.destination_countryFltr,
      };
    } else {
      data = {
        daterange: {
          datefield: 'create_datetime',
          fromdate: this.fromdateFltr,
          todate: this.todateFltr,
        },
        closed: this.closedFltr,
        mawb: this.mawb,
        shipmentID: this.shipmentIDFltr,
        palletIDList: this.palletIDListFltr,
        destination_country: this.destination_countryFltr,
      };
    }
    if (!data?.closed[0]) {
      delete data.closed;
    }
    if (!data?.mawb[0]) {
      delete data.mawb;
    }
    if (!data?.shipmentID[0]) {
      delete data.shipmentID;
    }
    if (!data?.palletIDList[0]) {
      delete data.palletIDList;
    }
    if (!data?.destination_country[0]) {
      delete data.destination_country;
    }

    this.mawbService.getMawbList(data).subscribe(data => {
      this.assignMawbsTodataSource(data);
    });
    this.AdvFilterForm.reset();
    this.closedFltr = [];
    this.mawb = [];
    this.shipmentIDFltr = [];
    this.palletIDListFltr = [];
    this.destination_countryFltr = [];
  }

  assignMawbsTodataSource(data) {
    this.defaultMawbList = this.mawbData = convertMawb(data);
    this.onStatusTabChange({ index: 0 });
    this.changeDetectorRef.detectChanges();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  getCustomerCredentialConfig() {
    this.configService.fetchConfig('customer_credential').then(response => {
      this.postalLocationApiKey =
        response && Object.keys(response).length != 0 && response.data[0]?.postalLocationApiKey
          ? response.data[0].postalLocationApiKey
          : '';
      this.mydhlApiKey =
        response && Object.keys(response).length != 0 && response.data[0]?.mydhlApiKey
          ? response.data[0].mydhlApiKey
          : '';
      this.mydhlApiPassword =
        response && Object.keys(response).length != 0 && response.data[0]?.mydhlApiPassword
          ? response.data[0].mydhlApiPassword
          : '';
    });
  }
  openCustomerCredentialNav(msg) {
    const dialogRef = this.dialog.open(InvalidDialogComponent, {
      data: {
        message: msg,
      },
    });
    dialogRef.afterClosed().subscribe(res => {
      this.dialog.closeAll();
      if (res == 'true') {
        this.behaviorService.sendEvent(res);
        this.router.navigateByUrl('/customer-onboarding');
      }
    });
  }
  getWorkflowConfig() {
    this.configService.fetchConfig('loose_bbx').then(response => {
      this.bbxWorkflow = response.data[0];
      this.looseBbx = this.bbxWorkflow === 'Yes' ? true : false;
      if (this.looseBbx) {
        this.displayedColumns = this.displayedColumns.filter(
          item => item !== 'motherShipperAddress'
        );
      }
    });
  }

  isAdvancedFilterCheck() {
    return !(
      this.AdvFilterForm.get('mawb').valid ||
      this.AdvFilterForm.get('shipmentID').valid ||
      this.AdvFilterForm.get('palletIDList').valid ||
      this.AdvFilterForm.get('closed').valid ||
      this.AdvFilterForm.get('destination_country').valid ||
      (this.AdvFilterForm.get('startDate').valid && this.AdvFilterForm.get('endDate').valid)
    );
  }

  addDgValues(element) {
    this.configService.getConfigs(['baby_default_options']).then(response => {
      if (response) {
        this.showDGContentID = response[0]?.data[0]?.showDGContentID;
        const data = {
          mawb: [element.mawb],
        };
        this.mawbService.getMawbList(data).subscribe(response => {
          let isPalletsClosed = true;
          if (response[0]?.palletIDList && response[0]?.palletIDList?.length > 0) {
            for (let j = 0; j < response[0]?.palletIDList?.length; j++) {
              if (!response[0]?.palletIDList[j]?.closed) {
                isPalletsClosed = false;
                break;
              } else {
                isPalletsClosed = true;
              }
            }
          }

          if (!isPalletsClosed) {
            this.errorDialogService.openDialog('alert.motherPalletNotClosed', false);
          } else {
            const isDgContent = response[0]?.isDgContent;
            if (this.showDGContentID && !isDgContent) {
              this.openDgContentId(element);
            } else {
              this.openDialogAction(element.mawb, 'close');
            }
          }
        });
      }
    });
  }

  openDgContentId(element) {
    const dialogRef = this.dialog.open(DgContentComponent, {
      autoFocus: false,
      width: '40vw',
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {
        mawbId: element.MAWB,
        dgContentId: element.DGContentID,
        customDescription: element.DGCustomDescription?.filter(e => e),
        DGPackageData: element.DGPackageData || [],
      },
    });
    dialogRef.afterClosed().subscribe(data => {
      this.openDialogAction(element.mawb, 'close');
      if (data) {
        this.getMawbList();
      }
    });
  }
}
